import { useJobStatusEvents } from "~/jobs/data-source/use-job-status-events";

/**
 * Mounts the single app-wide live job-status poller. Rendered once inside the authenticated shell,
 * alongside NotificationToastHost.
 */
export function JobEventsHost() {
  useJobStatusEvents();
  return null;
}
